import * as z from 'zod/mini'
import {uuid} from './types'


export const calculationUuid = uuid().brand<'CalculationUuid'>()
export type CalculationUuid = z.infer<typeof calculationUuid>

export const calculationResultUuid = uuid().brand<'CalculationResultUuid'>()
export type CalculationResultUuid = z.infer<typeof calculationResultUuid>

export const logfileUuid = uuid().brand<'LogfileUuid'>()
export type LogfileUuid = z.infer<typeof logfileUuid>

export const publicFileUuid = uuid().brand<'PublicFileUuid'>()
export type PublicFileUuid = z.infer<typeof publicFileUuid>

export const emailAttemptUuid = uuid().brand<'EmailAttemptUuid'>()
export type EmailAttemptUuid = z.infer<typeof emailAttemptUuid>

export const contactEmailUuid = uuid().brand<'ContactEmailUuid'>()
export type ContactEmailUuid = z.infer<typeof contactEmailUuid>

export const telephoneUuid = uuid().brand<'TelephoneUuid'>()
export type TelephoneUuid = z.infer<typeof telephoneUuid>

export const vehicleUuid = uuid().brand<'VehicleUuid'>()
export type VehicleUuid = z.infer<typeof vehicleUuid>

export const companyUuid = uuid().brand<'CompanyUuid'>()
export type CompanyUuid = z.infer<typeof companyUuid>

export const terminationUuid = uuid().brand<'TerminationUuid'>()
export type TerminationUuid = z.infer<typeof terminationUuid>

// Insurances

export const allianzContractUuid = uuid().brand<'AllianzContractUuid'>()
export type AllianzContractUuid = z.infer<typeof allianzContractUuid>

export const allianzDocumentUuid = uuid().brand<'AllianzDocumentUuid'>()
export type AllianzDocumentUuid = z.infer<typeof allianzDocumentUuid>

export const allianzRecordEmailUuid = uuid().brand<'AllianzRecordEmailUuid'>()
export type AllianzRecordEmailUuid = z.infer<typeof allianzRecordEmailUuid>

export const csobContractUuid = uuid().brand<'CsobContractUuid'>()
export type CsobContractUuid = z.infer<typeof csobContractUuid>

export const csobDocumentUuid = uuid().brand<'CsobDocumentUuid'>()
export type CsobDocumentUuid = z.infer<typeof csobDocumentUuid>

export const csobContractEmailUuid = uuid().brand<'CsobContractEmailUuid'>()
export type CsobContractEmailUuid = z.infer<typeof csobContractEmailUuid>

export const generaliContractUuid = uuid().brand<'GeneraliContractUuid'>()
export type GeneraliContractUuid = z.infer<typeof generaliContractUuid>

export const generaliDocumentUuid = uuid().brand<'GeneraliDocumentUuid'>()
export type GeneraliDocumentUuid = z.infer<typeof generaliDocumentUuid>

export const generaliRecordEmailUuid = uuid().brand<'GeneraliRecordEmailUuid'>()
export type GeneraliRecordEmailUuid = z.infer<typeof generaliRecordEmailUuid>

export const genertelContractUuid = uuid().brand<'GenertelContractUuid'>()
export type GenertelContractUuid = z.infer<typeof genertelContractUuid>

export const genertelDocumentUuid = uuid().brand<'GenertelDocumentUuid'>()
export type GenertelDocumentUuid = z.infer<typeof genertelDocumentUuid>

export const genertelRecordEmailUuid = uuid().brand<'GenertelRecordEmailUuid'>()
export type GenertelRecordEmailUuid = z.infer<typeof genertelRecordEmailUuid>

export const komunalnaContractUuid = uuid().brand<'KomunalnaContractUuid'>()
export type KomunalnaContractUuid = z.infer<typeof komunalnaContractUuid>

export const komunalnaDocumentUuid = uuid().brand<'KomunalnaDocumentUuid'>()
export type KomunalnaDocumentUuid = z.infer<typeof komunalnaDocumentUuid>

export const komunalnaRecordEmailUuid = uuid().brand<'KomunalnaRecordEmailUuid'>()
export type KomunalnaRecordEmailUuid = z.infer<typeof komunalnaRecordEmailUuid>

export const kooperativaContractUuid = uuid().brand<'KooperativaContractUuid'>()
export type KooperativaContractUuid = z.infer<typeof kooperativaContractUuid>

export const kooperativaDocumentUuid = uuid().brand<'KooperativaDocumentUuid'>()
export type KooperativaDocumentUuid = z.infer<typeof kooperativaDocumentUuid>

export const kooperativaRecordEmailUuid = uuid().brand<'KooperativaRecordEmailUuid'>()
export type KooperativaRecordEmailUuid = z.infer<typeof kooperativaRecordEmailUuid>

export const unionContractUuid = uuid().brand<'UnionContractUuid'>()
export type UnionContractUuid = z.infer<typeof unionContractUuid>

export const unionDocumentUuid = uuid().brand<'UnionDocumentUuid'>()
export type UnionDocumentUuid = z.infer<typeof unionDocumentUuid>

export const unionRecordEmailUuid = uuid().brand<'UnionRecordEmailUuid'>()
export type UnionRecordEmailUuid = z.infer<typeof unionRecordEmailUuid>

export const uniqaContractUuid = uuid().brand<'UniqaContractUuid'>()
export type UniqaContractUuid = z.infer<typeof uniqaContractUuid>

export const uniqaDocumentUuid = uuid().brand<'UniqaDocumentUuid'>()
export type UniqaDocumentUuid = z.infer<typeof uniqaDocumentUuid>

export const uniqaRecordEmailUuid = uuid().brand<'UniqaRecordEmailUuid'>()
export type UniqaRecordEmailUuid = z.infer<typeof uniqaRecordEmailUuid>

export const wustenrotContractUuid = uuid().brand<'WustenrotContractUuid'>()
export type WustenrotContractUuid = z.infer<typeof wustenrotContractUuid>

export const wustenrotDocumentUuid = uuid().brand<'WustenrotDocumentUuid'>()
export type WustenrotDocumentUuid = z.infer<typeof wustenrotDocumentUuid>

export const wustenrotRecordEmailUuid = uuid().brand<'WustenrotRecordEmailUuid'>()
export type WustenrotRecordEmailUuid = z.infer<typeof wustenrotRecordEmailUuid>

export const contractUuid = z.union([
  allianzContractUuid,
  csobContractUuid,
  generaliContractUuid,
  genertelContractUuid,
  komunalnaContractUuid,
  kooperativaContractUuid,
  unionContractUuid,
  uniqaContractUuid,
  wustenrotContractUuid,
])
export type ContractUuid = AllianzContractUuid
  | CsobContractUuid
  | GeneraliContractUuid
  | GenertelContractUuid
  | KomunalnaContractUuid
  | KooperativaContractUuid
  | UnionContractUuid
  | UniqaContractUuid
  | WustenrotContractUuid

export type DocumentUuid = AllianzDocumentUuid
  | CsobDocumentUuid
  | GeneraliDocumentUuid
  | GenertelDocumentUuid
  | KomunalnaDocumentUuid
  | KooperativaDocumentUuid
  | UnionDocumentUuid
  | UniqaDocumentUuid
  | WustenrotDocumentUuid
